import * as React from "react";
import { User } from "../../userTypes";

import {
  ThirdPartyVerification,
  ThirdPartyVerificationQuery,
} from "../../../ThirdPartyVerification";

type Props = {
  user: User;
  onUserChanged: (user: User) => void;
};

export default class ManualVerificationThirdPartyVerification extends React.Component<
  Props
> {
  constructor(props: Props) {
    super(props);
    props.onUserChanged(props.user);
  }

  componentWillReceiveProps(newProps: Props) {
    if (newProps.user !== this.props.user) {
      newProps.onUserChanged(newProps.user);
    }
  }

  render() {
    return (
      <section>
        <h4
          style={{
            borderBottom: "1px solid rgb(204, 204, 204)",
            fontWeight: 400,
            display: "flex",
            alignItems: "center",
          }}
        >
          <p style={{ flex: 1 }}>Third party identity verification</p>
        </h4>
        {this.props.user.identity_number == null ? (
          <div>There is no ID number associated with this user's account.</div>
        ) : (
          <>
            <div>
              <b> ID number info (Home Affairs): </b>
              <ThirdPartyVerification
                description="ID number info (Home Affairs)"
                queryType={ThirdPartyVerificationQuery.ProfileId}
              >
                {this.props.user.identity_number}
              </ThirdPartyVerification>
            </div>

            <div>
              <b>ID number info (Home Affairs Real Time): </b>
              <ThirdPartyVerification
                description="ID number info (Home Affairs Real Time)"
                queryType={ThirdPartyVerificationQuery.RealTimeId}
              >
                {this.props.user.identity_number}
              </ThirdPartyVerification>
            </div>
          </>
        )}
      </section>
    );
  }
}
